import React from 'react';
export function Footer() {
  return <footer className="bg-ink-950 px-4 pb-28 pt-10 text-center md:pb-10" data-id="element-177" data-mp="19ivlq3plplne">
      <p className="text-[16px] font-extrabold text-white" data-id="element-178" data-mp="206j57nelojgi">Endodontic Retreatment Decision Blueprint™</p>
      <p className="mx-auto mt-2 max-w-md text-sm text-mist-300" data-id="element-179" data-mp="2f3ijfu3yjajy">
        Practical assessment, planning, and documentation tools for qualified dental professionals.
      </p>
      <p className="mt-6 text-xs text-mist-500" data-id="element-180" data-mp="1mfml6kyqpal2">© {new Date().getFullYear()} Dr. Valeria Montes. All rights reserved.</p>
    </footer>;
}